<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-11-04 09:41:54
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-11-11 11:14:50
-->
<template>
  <div class="CustomHead">
    <div class="headerStatus">
      <img :class="{loading: srcName === 'loading.png'}" :src="isSrcName" alt="" />
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CustomHead',
  props: ['srcName'],
  computed: {
    isSrcName() {
      // eslint-disable-next-line import/no-dynamic-require
      return require(`@/assets/images/${this.srcName}`);
    },
  },
  mounted() {
    console.log(this.isSrcName);
  },
};
</script>
<style scoped>
.headerStatus {
  padding-top: 70px;
}
.headerStatus img {
  width: 60px;
  height: 60px;
}
.headerStatus h3 {
  font-size: 18px;
}
.headerStatus p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.loading{
  animation: load-effect 2.5s infinite linear;
}
@keyframes load-effect {
   0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
   }
   100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
   }
}
</style>
